// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__geJBx","cell":"ColumnAccessor_cell__3MyWk","firstCellAccent":"ColumnAccessor_firstCellAccent__2AFXD"};